
const m = window.require("@ember/destroyable");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
